import React, { useState } from "react";

export const states = {
    SEARCH_PET:         0,
    CREATE_NEW_OWNER:   1,
    CREATE_NEW_PET:     2,
    PET_SELECTED:       3,
    JOURNAL_SHOWN:      4,
    BUTTON_SELECT:      5,
    CALENDAR:           6
}

const AdminStateContext = React.createContext();

export default AdminStateContext;